import styled from 'styled-components';

export const TrilhaContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h2 {
    margin-top: 1.6rem;
    font-size: 1.1rem;
    line-height: 1.3rem;
    text-transform: uppercase;
  }
  @media (max-width: 1367px) {
    width: 100%;
    max-width: calc(1367px -6rem);
  }
`;

export const Trilha = styled.div`
  padding: 0.5rem;
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 769px) {
    width: calc(100vw - 7rem);
    overflow-x: scroll;
  }
  @media (max-width: 600px) {
    padding: 2rem 2rem 4rem 7rem;
    width: 100%;
    max-width: 100vw;
    overflow-x: auto;
  }
`;

export const Circle = styled.div`
  border-radius: 50%;
  width: 83px;
  height: 73px;
  z-index: 100;

  background-color: #fff7df;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & p {
    font-size: 0.6rem;
    font-weight: 700;
    color: #5b5b5b;
    text-transform: uppercase;
    text-align: center;
  }

  &:first-child {
    margin-left: 0;
  }

  @media (max-width: 1025px) {
    width: 63px;
    height: 53px;
    margin-top: -2rem;
  }
`;

interface CaminhoTrilhaProps {
  width: string;
}

export const CaminhoTrilha = styled.div<CaminhoTrilhaProps>`
  position: relative;
  width: ${(props) => props.width};
  height: 80px;
  margin: 0 0.8rem;
  background-color: #fff7df;
  z-index: 70;

  border: 1px solid #ccc;
  border-radius: 5px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  img {
    position: absolute;
    margin: 0.3rem;
    left: 0;
    width: 12px;
    height: 12px;
  }

  @media (max-width: 1367px) {
    width: 120px;
    margin-bottom: 2rem;
  }
  // @media (max-width: 1025px) {
  //   width: 6rem;
  //   height: 60px;
  }
  // @media (max-width: 600px) {
  //   margin: 0 0.5rem 2rem 0;
  // }
`;

export const CaminhoAcessoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 20px;
  margin-right: 10px;
  z-index: 80;
  div {
    &:first-child {
      margin-bottom: 4px;
    }
  }
`;

interface TrilhaItemProps {
  isAcesso?: boolean;
  isNavegacao?: boolean;
}

export const TrilhaItem = styled.div<TrilhaItemProps>`
  margin-top: ${(props) => (props.isNavegacao ? '1rem' : '0.6rem')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  strong,
  p {
    font-size: 0.87rem;
    margin-top: ${(props) => (props.isAcesso ? '1rem' : '0')};
  }

  .identificacao {
    margin-top: 0.6rem;
  }
  @media (max-width: 1025px) {
    strong,
    p {
      font-size: 8px;
      margin-top: ${(props) => (props.isAcesso ? '1rem' : '0')};
    }

    .identificacao {
      margin-top: 0.2rem;
    }
  }
`;

export const TrilhaFooter = styled.div`
  width: 100%;
  height: 20px;

  background-color: var(--color-primary);
  border-radius: 0px 0px 3px 3px;

  display: flex;
  align-items: center;
  justify-content: center;

  strong {
    font-size: 0.86rem;
    color: #fff;
  }
  @media (max-width: 1025px) {
    height: 15px;
    strong {
      font-size: 8px;
    }
  }
`;

interface LineProps {
  width?: string;
  height?: string;
  margin?: string;
  marginTop?: string;
}

export const LineTrilha = styled.div<LineProps>`
  position: absolute;
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  display: flex;
  margin-top: ${(props) => props.marginTop};
  margin-right: ${(props) => props.margin};
  border: 4px solid #bbbbbb;
  @media (max-width: 1367px) {
    display: none;
    // margin: auto;
    // width: calc(100% - 6rem);
    // left: 6rem;
    // margin-top: -17rem;
    // // z-index: 300;
    // background-color: red;
  }
`;

export const Line = styled.div<LineProps>`
  position: absolute;
  width: 1150px;
  height: 1px;
  display: flex;
  left: 450px;
  margin-top: 50px;
  border: 4px solid #bbbbbb;
`;
